/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import vajralog from "../assets/images/vajra_logo.svg";
import { getConsultantLogoUrl } from "../utils/consultantLogo";
import { useLocation, useNavigate } from "react-router-dom";
import { sidebarElements1, sidebarElementsFacility } from "../utils/constant";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import styles from "../styles/layout/groupAdminSidebar.module.css";
import { clsx } from "clsx";
import FeatureLockedModal from "../Components/Common/FeatureLockedModal";
import { useUser } from "../context/AuthContext";

const TrialUserSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();

  const [openSections, setOpenSections] = useState({});
  const [featureLockedModal, setFeatureLockedModal] = useState(false);

  const toggleSection = (heading) => {
    setOpenSections((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  console.log("module", user?.modules);

  // Helper function to check if item should be shown for end user based on modules
  const isModuleAllowed = (itemModuleName, subHeading = null) => {
    if (!user?.endUser || !user?.modules || !Array.isArray(user.modules)) {
      return true; // If not end user or no modules, show all
    }

    // If no moduleName, check if it's a default allowed subHeading
    if (!itemModuleName) {
      // Allow default subHeadings that are always visible
      if (subHeading === "Overview" || subHeading === "GHG Accounting") {
        return true;
      }
      return false; // Hide items without moduleName for end users
    }

    // Check if any user module matches or is a child of this item's module
    return user.modules.some((userModule) => {
      // Exact match
      if (userModule === itemModuleName) {
        return true;
      }
      // Check if userModule starts with itemModuleName (parent match)
      // e.g., "Environment | Scope 1 | Stationary Combustion" starts with "Environment"
      if (userModule.startsWith(itemModuleName + " |")) {
        return true;
      }
      // Check if itemModuleName starts with userModule (child match)
      // e.g., "Environment" starts with "Environment | Scope 1"
      if (itemModuleName.startsWith(userModule + " |")) {
        return true;
      }
      return false;
    });
  };

  const filterSidebar = (items) => {
    console.log("firstjson", JSON.stringify(items));
    return items
      .map((item) => {
        // Filter out "Production & Revenue" for end users
        // if (user?.endUser && item.moduleName === "Production & Revenue") {
        //   return null;
        // }

        // Always show default items for end users (Overview, Support, FAQ, Settings)
        if (
          item.heading === "Overview" ||
          item.heading === "Support" ||
          item.heading === "FAQ" ||
          item.heading === "Settings"
        ) {
          return item;
        }

        // Handle subData (nested children) - filter recursively first
        if (item.subData) {
          const filteredSub = filterSidebar(item.subData);
          if (filteredSub.length > 0) {
            // If filtered subData exists, return parent with filtered children
            return { ...item, subData: filteredSub };
          }
          // If no filtered children, don't show parent for end users
          if (user?.endUser) {
            return null;
          }
        }

        // Handle subChildren - filter recursively
        if (item.subChildren) {
          const filteredSubChildren = filterSidebar(item.subChildren);
          if (filteredSubChildren.length > 0) {
            return { ...item, subChildren: filteredSubChildren };
          }
          // If no filtered children, don't show parent for end users
          if (user?.endUser) {
            return null;
          }
        }

        // For end users, filter by modules (check both moduleName and subHeading)
        if (user?.endUser) {
          // If item has moduleName, check if it's allowed
          if (item.moduleName) {
            if (!isModuleAllowed(item.moduleName, item.subHeading)) {
              return null;
            }
          } else if (item.subHeading) {
            // If item has subHeading but no moduleName, check if subHeading is allowed
            if (!isModuleAllowed(null, item.subHeading)) {
              return null;
            }
          } else {
            // If item has neither moduleName nor subHeading, hide it
            return null;
          }
        }

        // Handle subChildren
        if (item.subChildren) {
          const filteredSubChildren = filterSidebar(item.subChildren);
          if (filteredSubChildren.length > 0) {
            return { ...item, subChildren: filteredSubChildren };
          }
        }

        // Handle subsubChildren - filter by modules for end users
        if (item.subsubChildren) {
          const filteredSubSubChildren = user?.endUser
            ? item.subsubChildren.filter((subItem) =>
              isModuleAllowed(subItem.moduleName, subItem.text)
            )
            : item.subsubChildren;
          if (filteredSubSubChildren.length > 0) {
            return { ...item, subsubChildren: filteredSubSubChildren };
          }
        }

        // For end users, only return items with allowed moduleName or subHeading
        if (user?.endUser) {
          if (item.moduleName && isModuleAllowed(item.moduleName, item.subHeading)) {
            return item;
          }
          if (!item.moduleName && item.subHeading && isModuleAllowed(null, item.subHeading)) {
            return item;
          }
          return null;
        }

        // For non-end users, return items with moduleName
        if (item.moduleName) {
          return item;
        }

        return null;
      })
      .filter(Boolean); // Remove null entries
  };

  // Helper to recursively find which sections should be open for a given path
  function getOpenSectionsForPath(elements, pathname) {
    const open = {};
    elements.forEach((section) => {
      // Top-level
      if (section.collapse && section.subData) {
        section.subData.forEach((item) => {
          if (isPathMatchOrNested(item, pathname)) {
            open[section.heading] = true;
            if (item.subHeading) {
              open[item.subHeading] = true;
            }
          }
        });
      }
      // Top-level direct path
      if (section.path && pathname.startsWith(section.path)) {
        open[section.heading] = true;
      }
    });
    return open;
  }

  // Helper to check if a subData/subChildren/subsubChildren item matches the path
  function isPathMatchOrNested(item, pathname) {
    // Direct path or url
    if (
      (item.path && pathname.startsWith(item.path)) ||
      (item.url && pathname.startsWith(item.url))
    ) {
      return true;
    }
    // subcollapse (subChildren)
    if (item.subcollapse && item.subChildren) {
      return item.subChildren.some((sub) => isPathMatchOrNested(sub, pathname));
    }
    // collapse (subsubChildren)
    if (item.collapse && item.subsubChildren) {
      return item.subsubChildren.some((sub) =>
        isPathMatchOrNested(sub, pathname)
      );
    }
    return false;
  }

  useEffect(() => {
    // Use the filtered sidebar for the current user
    const elements = filterSidebar(sidebarElements1);

    setOpenSections(getOpenSectionsForPath(elements, location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const renderSidebarItems = (elements) => {
    const allowedHeadings = ["Overview", "Environment", "Setup"];
    const allowedSubHeadings = ["GHG Accounting"];
    const allowedSetupSubHeadings = [
      "Masters",
      "Roles and Permissions",
      "Facility Master",
    ];
    const allowedSubChildren = ["Scope 1", "Scope 2", "Scope 3"];

    // Helper to check if a subData item is enabled
    const isSubDataEnabled = (item, sectionHeading) => {
      // Overview subHeading should always be enabled
      if (item.subHeading === "Overview") {
        return true;
      }
      if (sectionHeading === "Setup") {
        return allowedSetupSubHeadings.includes(item.subHeading);
      }
      return allowedSubHeadings.includes(item.subHeading);
    };

    // Helper to check if a subChild item is enabled
    const isSubChildEnabled = (subItem) => {
      return allowedSubChildren.includes(subItem.primary);
    };

    return elements.map((section, index) => {
      // Overview should never be disabled
      const isDisabled = section.heading === "Overview" 
        ? false 
        : !allowedHeadings.includes(section.heading);
      return (
        <div key={index} className={styles.sidebarSection} >
          {section.heading && (
            <div className={styles.sectionHeadingRow} style={{
              backgroundColor: isDisabled ? "#EFEEEE" : "#FFFFFF",

            }}>
              <div
                className={clsx(
                  styles.sectionHighlight,
                  !isDisabled &&
                  location.pathname.startsWith(section.path) &&
                  styles.sectionHighlightActive
                )}
              ></div>
              <a
                href={isDisabled ? "#" : section.path}
                onClick={(e) => {
                  if (isDisabled) {
                    e.preventDefault();
                    setFeatureLockedModal(true);
                    return;
                  }
                  if (section.collapse) {
                    e.preventDefault();
                    toggleSection(section.heading);
                  }
                }}
                className={clsx(
                  styles.sectionLink,
                  !section?.collapse &&
                  !isDisabled &&
                  location.pathname.startsWith(section.path) &&
                  styles.sectionLinkActive,
                  isDisabled && styles.sectionLinkDisabled
                )}
              >
                <Box
                  component="img"
                  src={section.icon}
                  alt="icon"
                  sx={{
                    width: "20px",
                    height: "20px",
                    marginRight: "8px",
                    filter:
                      !section?.collapse &&
                        !isDisabled &&
                        location.pathname.startsWith(section.path)
                        ? "invert(1)"
                        : "invert(0)",
                  }}
                />
                <span className={styles.sectionHeadingText}>
                  {section.heading}
                </span>
                {section.collapse &&
                  !isDisabled &&
                  (openSections[section.heading] ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  ))}
              </a>
            </div>
          )}

          {section.subData &&
            !isDisabled &&
            (!section.collapse || openSections[section.heading]) &&
            section.subData.map((item) => {
              const isSubDisabled = !isSubDataEnabled(item, section.heading);
              return (
                <div
                  key={item.path || item.url}
                  className={styles.subDataContainer}
                >
                  {item.subHeading ? (
                    item.subcollapse ? (
                      // If subcollapse is true, it acts as a collapsible section
                      <div
                        onClick={() => {
                          if (isSubDisabled) {
                            setFeatureLockedModal(true);
                          } else {
                            toggleSection(item.subHeading);
                          }
                        }}
                        className={clsx(
                          styles.subCollapseSection,
                          isSubDisabled && styles.sectionLinkDisabled
                        )}
                      >
                        <div className={styles.subCollapseHeader}>
                          <Box
                            component="img"
                            src={item.icon}
                            alt="img"
                            sx={{
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                              filter:
                                !isSubDisabled &&
                                  location.pathname.startsWith(
                                    item.path || item.url
                                  )
                                  ? "invert(1)"
                                  : "invert(0)",
                            }}
                          />
                          {item.subHeading}
                        </div>
                        {!isSubDisabled &&
                          (openSections[item.subHeading] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          ))}
                      </div>
                    ) : (
                      // If subcollapse is false, make it a clickable link
                      <a
                        href={isSubDisabled ? "#" : item.path || item.url}
                        onClick={(e) => {
                          if (isSubDisabled) {
                            e.preventDefault();
                            setFeatureLockedModal(true);
                          }
                        }}
                        className={clsx(
                          styles.subDataLink,
                          !isSubDisabled &&
                          location.pathname.startsWith(
                            item.path || item.url
                          ) &&
                          styles.subDataLinkActive,
                          isSubDisabled && styles.sectionLinkDisabled
                        )}
                      >
                        <Box
                          component="img"
                          src={item.icon}
                          alt="img"
                          sx={{
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                            filter:
                              !isSubDisabled &&
                                location.pathname.startsWith(
                                  item.path || item.url
                                )
                                ? "invert(1)"
                                : "invert(0)",
                          }}
                        />
                        <Typography
                          className={clsx(
                            styles.subDataText,
                            !isSubDisabled &&
                            location.pathname.startsWith(
                              item.path || item.url
                            ) &&
                            styles.subDataTextActive
                          )}
                        >
                          {item.subHeading}
                        </Typography>
                      </a>
                    )
                  ) : (
                    <a
                      href={isSubDisabled ? "#" : item.path || item.url}
                      onClick={(e) => {
                        if (isSubDisabled) {
                          e.preventDefault();
                          setFeatureLockedModal(true);
                        }
                      }}
                      className={clsx(
                        styles.subDataLink,
                        !isSubDisabled &&
                        location.pathname.startsWith(item.path || item.url) &&
                        styles.subDataLinkActive,
                        styles.subDataLinkNoHeading,
                        isSubDisabled && styles.sectionLinkDisabled
                      )}
                    >
                      <Box
                        component="img"
                        src={item.icon}
                        alt="icon"
                        sx={{
                          width: "20px",
                          height: "20px",
                          marginRight: "8px",
                          filter:
                            !isSubDisabled &&
                              location.pathname.startsWith(item.path || item.url)
                              ? "invert(1)"
                              : "invert(0)",
                        }}
                      />
                      <Typography
                        className={clsx(
                          styles.subDataText,
                          !isSubDisabled &&
                          location.pathname.startsWith(
                            item.path || item.url
                          ) &&
                          styles.subDataTextActive
                        )}
                      >
                        {item.primary}
                      </Typography>
                    </a>
                  )}

                  {item.subChildren &&
                    !isSubDisabled &&
                    openSections[item.subHeading] &&
                    item.subChildren.map((subItem) => {
                      const isSubChildDisabled = !isSubChildEnabled(subItem);
                      return (
                        <a
                          key={subItem.path}
                          href={isSubChildDisabled ? "#" : subItem.path}
                          onClick={(e) => {
                            if (isSubChildDisabled) {
                              e.preventDefault();
                              setFeatureLockedModal(true);
                            }
                          }}
                          className={clsx(
                            styles.subChildLink,
                            !isSubChildDisabled &&
                            location.pathname.startsWith(subItem.path) &&
                            styles.subChildLinkActive,
                            isSubChildDisabled && styles.sectionLinkDisabled
                          )}
                        >
                          <Box
                            component="img"
                            src={subItem.icon}
                            alt={"icon"}
                            sx={{
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                              filter:
                                !isSubChildDisabled &&
                                  location.pathname.startsWith(subItem.path)
                                  ? "invert(1)"
                                  : "invert(0)",
                            }}
                          />
                          <Typography
                            className={clsx(
                              styles.subChildText,
                              !isSubChildDisabled &&
                              location.pathname.startsWith(subItem.path) &&
                              styles.subChildTextActive
                            )}
                          >
                            {subItem?.primary}
                          </Typography>
                          {!isSubChildDisabled && (
                            <div key={index} className={styles.subSubContainer}>
                              <div
                                className={styles.subSubHeader}
                                onClick={() =>
                                  toggleSection(subItem.subHeading)
                                }
                              >
                                <span className={styles.subSubHeadingText}>
                                  {subItem?.subHeading}
                                </span>
                                {subItem?.collapse &&
                                  (openSections[subItem?.subHeading] ? (
                                    <ExpandLess />
                                  ) : (
                                    <ExpandMore />
                                  ))}
                              </div>
                              {subItem?.subsubChildren &&
                                openSections[subItem.subHeading] &&
                                subItem?.subsubChildren?.map((subItems) => (
                                  <a
                                    key={subItems.path}
                                    href={subItems.path}
                                    className={clsx(
                                      styles.subSubLink,
                                      location.pathname.startsWith(
                                        subItems.path
                                      ) && styles.subSubLinkActive
                                    )}
                                  >
                                    <Box
                                      component="img"
                                      src={subItems.icon}
                                      alt={"icon"}
                                      sx={{
                                        width: "20px",
                                        height: "20px",
                                        marginLeft: "8px",
                                        filter: location.pathname.startsWith(
                                          subItems.path
                                        )
                                          ? "invert(0)"
                                          : "invert(1)",
                                      }}
                                    />
                                    <Typography
                                      className={clsx(
                                        styles.subSubText,
                                        location.pathname.startsWith(
                                          subItems.path
                                        ) && styles.subSubTextActive
                                      )}
                                    >
                                      {subItems?.text}
                                    </Typography>
                                  </a>
                                ))}
                            </div>
                          )}
                        </a>
                      );
                    })}
                </div>
              );
            })}
        </div>
      );
    });
  };

  return (
    <>
      <Box className={styles.sidebarRoot}>
        <Box>
          <Box className={styles.logoContainer}>
            <img
              src={getConsultantLogoUrl() || vajralog}
              alt="Nirantara Logo"
              className={styles.logoImage}
              onClick={() => navigate("/dashboard")}
            />
          </Box>
          <Divider />
          <div className={styles.sidebarContent}>
            {renderSidebarItems(
              filterSidebar(
                user?.facilityManger || user?.endUser
                  ? sidebarElementsFacility
                  : sidebarElements1
              )
            )}
          </div>
        </Box>
      </Box>

      {/* Feature Locked Modal */}
      <FeatureLockedModal
        open={featureLockedModal}
        onClose={() => setFeatureLockedModal(false)}
      />
    </>
  );
};

export default TrialUserSidebar;
